import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExpirationService {


constructor(private http:HttpClient) { }


GetRecord(Token:String):Observable<Array<FeildActivity_Interface>>{
  return this.http.get(environment.BaseUrl + "Daro/Expiration?token="+Token).pipe(
    map(data=>{
      return data as Array<FeildActivity_Interface>
    })
  )
}

GetActive(Token:String):Observable<Array<FeildActivity_Interface>>{
  return this.http.get(environment.BaseUrl + "Daro/Expiration/GetActive?token="+Token).pipe(
    map(data=>{
      return data as Array<FeildActivity_Interface>
    })
  )
}

GetActiveAndId(Token:String,id:number):Observable<Array<FeildActivity_Interface>>{
  return this.http.get(environment.BaseUrl + "Daro/Expiration/GetActiveAndId?token="+Token+"&id="+id).pipe(
    map(data=>{
      return data as Array<FeildActivity_Interface>
    })
  )
}

GetSingle(Token:String,id:Number):Observable<FeildActivity_Interface>{
  return this.http.get(environment.BaseUrl + "Daro/Expiration/GetSingle?token="+Token+"&id="+id).pipe(
    map(data=>{
      return data as FeildActivity_Interface
    })
  )
}

AddExpiration(model: FeildActivity_Interface,Token:String):Observable<FeildActivity_Interface>{
  const headers = new HttpHeaders().set('content-type', 'application/json');


  var body = {
    id:model.id,
    Title:model.title,
    day:Number(model.code),
    del:false,
    username:Token,
    subdate:null
  }


    return this.http.post(environment.BaseUrl + "Daro/Expiration/Add",body,{headers}).pipe(
      map(data=>{
        return data as FeildActivity_Interface
      })
    )

}

EditExpiration(model: FeildActivity_Interface,Token:String):Observable<FeildActivity_Interface>{
  const headers = new HttpHeaders().set('content-type', 'application/json');


  var body = {
    id:model.id,
    Title:model.title,
    day:Number(model.code),
    del:false,
    username:Token,
    subdate:null
  }


    return this.http.post(environment.BaseUrl + "Daro/Expiration/Edit",body,{headers}).pipe(
      map(data=>{
        return data as FeildActivity_Interface
      })
    )

}

DeleteExpiration(id:number,Token:String):Observable<FeildActivity_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Expiration/Delete?id="+id+"&token="+Token).pipe(
      map(data=>{
        return data as FeildActivity_Interface
      })
    )

}
DefaulttExpiration(id:number,Token:String):Observable<FeildActivity_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Expiration/Defaultt?id="+id+"&token="+Token).pipe(
      map(data=>{
        return data as FeildActivity_Interface
      })
    )

}


}
